<div>
    <div class="d-flex justify-content-between mb-2 pl-3 pt-2" style="background-color: #fafafa; margin: -20px">
        <h3 class="font-weight-bold m-0 mb-3 pt-1">{{'serviceagreement'|translate}}</h3>
        <mat-icon (click)="onCloseDialog()" class="cursor mr-2 mt-0">close</mat-icon>
    </div>
    <mat-dialog-content (scroll)="onScroll($event)">
        <mat-card class="card mb-3 privacy-container">
            <mat-tab-group class="col-12" [selectedIndex]="indexValue" (selectedIndexChange)="onChangeEvent($event)">
                <mat-tab *ngIf="appSubscriptionAgreement != ''" label="{{'SubscriptionAgreement'| translate}}">
                    <div class="col-12 mt-3" [innerHTML]="appSubscriptionAgreement">
                    </div>
                </mat-tab>
                <mat-tab *ngIf="appAgreement != ''" label="{{'AppAgreement'| translate}}">
                    <div class="col-12 mt-3" [innerHTML]="appAgreement">
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </mat-dialog-content>
    <div *ngIf="showActionButtons" mat-dialog-actions class="d-flex mb-2 justify-content-center">
        <div style="display: inline-block !important; width: 100%;
      margin-bottom: 8px;">
            <div class="d-flex mt-2 mr-2">
                <mat-checkbox [disabled]="!enableActionFirst" class="font-weight-bold" (change)="updateFirstTab($event)">{{'IUnderstoodSubscriptionAgreement'|translate}}</mat-checkbox>
            </div>
            <div class="mt-2 mr-2 d-flex">
                <mat-checkbox [disabled]="!enableActionSecond" class="font-weight-bold" (change)="updateSecondTab($event)">{{'IUnderstoodAppAgreement'|translate}}</mat-checkbox>
            </div>
        </div>
        <button (click)="onCloseDialog()" mat-raised-button type="submit" color="accent" class="card-header-action mr-3">{{'Cancel' | translate}}</button>
        <button (click)="selectPlan()" [disabled]="!(enableActionFirstSuccess && enableActionSecondSuccess) " mat-raised-button type="submit"
            color="primary" class="card-header-action mr-3">{{'Agree' | translate}}</button>
    </div>
</div>